/**
 * 기본(소속별 특수 처리 없음) 발주 전략
 *
 * 머큐리/삼성/장비불러 외 일반 소속에서 사용. 거래처/현장담당자 노출
 * 분기처럼 기존 Baljoo.js 의 else 블록을 담당.
 */
import Base from './Base';
import Util from '../../../Common/Util';

export default class Default extends Base {
    matches(/* sosok */) { return true; }  // fallback

    onInitPage() {
        $('.mercury-insurance').hide();
        $('.trade-contact').show();

        // 발주자/업체발주자는 거래처 안 보이게
        if (typeof MEMBER !== 'undefined' && MEMBER['mem_driver_type'] != '수발주자') {
            $('.trade-contact').hide();
            // 삼성 소속이면 현장담당자도 안 보이게
            if (Util.isSosokSamsung(MEMBER['sosok'])) {
                $('.field-contact').hide();
            }
        }
    }
}
